export enum ClientSubType {
  None = 0,
  FrontOffice = 1,
  BackOffice = 2,
  Portu26 = 3,
}
